import { useAuth } from "../context/auth";
import { useConsent } from "../context/consent";

export function HomePage() {
	const { user } = useAuth();
	useConsent(); // validates provider is mounted

	// --- Cookie Consent Gating Example ---
	// To conditionally load an analytics script based on user consent:
	//
	// import { useEffect } from "react";
	// import { useConsent } from "../context/consent";
	//
	// function MyComponent() {
	//   const { analytics } = useConsent();
	//
	//   useEffect(() => {
	//     if (!analytics) return;
	//     const script = document.createElement("script");
	//     script.src = "https://example.com/analytics.js";
	//     script.async = true;
	//     document.head.appendChild(script);
	//     return () => { document.head.removeChild(script); };
	//   }, [analytics]);
	//
	//   return <div>My component</div>;
	// }
	// --- End Cookie Consent Gating Example ---

	return (
		<div className="max-w-sm mx-auto mt-8">
			<h1 className="text-2xl font-bold text-gray-900 mb-4">Welcome</h1>
			<p data-testid="user-email">{user?.email}</p>
		</div>
	);
}
